import Divider from 'components/Divider';
import { ISettingsFormik } from '../../model';
import { FormikProps } from 'formik';
import { FC } from 'react';
import { Field, Switch } from 'shared/ui';
import { ITavusPersonaFormik, tavusPersonaStore } from 'entities/tavus/persona';
import FormInput from 'shared/ui/FormInput';

interface IProps {
  formik: FormikProps<ITavusPersonaFormik>;
}
export const GeneralSettings: FC<IProps> = ({ formik }) => {
  return (
    <>
      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label className="ag-text-base ag-font-semibold">
          Video Agent Name
        </label>
        <FormInput
          placeholder="Name"
          name="widget.video_agent_name"
          formik={formik}
          value={formik.values.widget.video_agent_name}
          className="ag-w-full"
        />
      </div>
      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label className="ag-text-base ag-font-semibold">
          Description (optional)
        </label>
        <FormInput
          name="widget.description"
          placeholder="Description"
          formik={formik}
          value={formik.values.widget.description}
          className="ag-w-full"
        />
      </div>
      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label className="ag-text-base ag-font-semibold">
          Start call Button
        </label>
        <FormInput
          name="widget.button_text"
          placeholder="text"
          formik={formik}
          value={formik.values.widget.button_text}
          className="ag-w-full"
        />
      </div>
      <Divider />
      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label className="ag-text-sm ag-font-semibold">
          Video Call Ended Custom Message
        </label>
        <FormInput
          name="widget.video_call_ended_custom_message"
          placeholder="text"
          formik={formik}
          value={formik.values.widget.video_call_ended_custom_message}
          className="ag-w-full"
        />
      </div>
      <div className="ag-flex ag-flex-col ag-gap-y-2">
        <label className="ag-text-base ag-font-semibold ag-my-2">
          Post Call CTA
        </label>
        <div className="ag-flex ag-flex-col ag-gap-y-2">
          <label className="ag-text-sm ag-font-semibold">
            Primary CTA Button Text
          </label>
          <FormInput
            name="widget.cta_primary_button_text"
            placeholder="Ttext"
            formik={formik}
            value={formik.values.widget.cta_primary_button_text}
            className="ag-w-full"
          />
          <label className="ag-text-base ag-font-semibold">
            Primary CTA Button link
          </label>
          <FormInput
            name="widget.cta_primary_button_link"
            placeholder="https://example.com"
            formik={formik}
            value={formik.values.widget.cta_primary_button_link}
            className="ag-w-full"
          />
          <label className="ag-text-sm ag-font-semibold">
            Secondary CTA Button Text
          </label>
          <FormInput
            name="widget.cta_secondary_button_text"
            placeholder="Text"
            formik={formik}
            value={formik.values.widget.cta_secondary_button_text}
            className="ag-w-full"
          />
          <label className="ag-text-base ag-font-semibold">
            Secondary Button link
          </label>
          <FormInput
            name="widget.cta_secondary_button_link"
            placeholder="https://example.com"
            formik={formik}
            value={formik.values.widget.cta_secondary_button_link}
            className="ag-w-full"
          />
        </div>
      </div>
      <Divider />
      <div>
        <div className="ag-flex ag-items-center ag-justify-between">
          <span className="ag-text-neutral-700 ag-font-medium">
            Form Enabled
          </span>
          <Switch
            onChange={(value) => {
              if (
                formik?.values?.preconversationConfig?.fields?.length &&
                value
              ) {
                formik.setFieldValue('widget.is_form_enabled', value);
              } else {
                formik.setFieldValue('widget.is_form_enabled', false);
              }
            }}
            checked={formik.values.widget.is_form_enabled}
          />
        </div>
        {!formik?.values?.preconversationConfig?.fields?.length && (
          <div className="ag-text-xs ag-text-neutral-300">
            You don&apos;t have a form to fill out to enable this switch.
          </div>
        )}
      </div>

      <div className="ag-flex ag-items-center ag-justify-between">
        <span className="ag-text-neutral-700 ag-font-medium">
          Powered by Yepic AI
        </span>
        <Switch
          onChange={(value) => formik.setFieldValue('widget.powered_by', value)}
          checked={formik.values.widget.powered_by}
        />
      </div>
    </>
  );
};
